export const KEY_SELECTED_ACCOUNT = 'SELFSERVICE_SELECTED_ACCOUNT';
export const KEY_ACCOUNTS = 'SELFSERVICE_ACCOUNTS';
export const KEY_IMPERSONATION = 'SELFSERVICE_IMPERSONATION';
